import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "7xdbeu0b",
  dataset: "development",
  // authenticated requests can't be cached so we have to set useCdn to false
  useCdn: false,
  token:
  // TODO #4 Sanity client token needs to be updated for production
    "sk4kALnxcVgTrRyRRRnFZMNPIK2nvTw5S5cZB1NFN7F0U39NyWehJLNYEwYjyST9fuofcv5fEBVvJQG9apGBPINtZddlaYpwcTP5NGKpAEvRiqyTdlsex4pRyDEDtxzTCytMKnEWFtSCEDjaaNTF19Mv2ZFDkoe0WX9H1tFGV4dhYAEDEYXI", 
});
